import { useEffect, useState } from "react";
import { reconcilePoItem } from "src/services/po-api";
import { useToast } from "src/hooks/useToast";
import { Spinner } from "src/components";
import moment from "moment";

const Reconcilliation = ({ orderProductId, company_code }: any) => {
  const [poDetails, setPoDetails] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { toast } = useToast();

  const fetchPoDetails = async () => {
    setIsLoading(true);
    try {
      const response = await reconcilePoItem({
        order_product_id: orderProductId,
        company_code: company_code,
      });
      const invoiceProductMappings = response?.data?.data?.invoiceProductMappings ?? [];
      const allReconciliations = invoiceProductMappings.flatMap((item: any) => item?.po_item?.mapReconciliations ?? []);
      setPoDetails(allReconciliations);
    } catch (error: any) {
      console.log(error);
      toast({
        title: "Error",
        description: error?.response?.data?.message || "Something went wrong",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  console.log("poDetails", poDetails);

  useEffect(() => {
    fetchPoDetails();
  }, [orderProductId]);

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center">
          <Spinner size="small" />
        </div>
      ) : poDetails?.length > 0 ? (
        <div className="overflow-x-scroll">
          <table className="min-w-full mt-2 border">
            <thead className="w-full">
              <tr>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Batch</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Reconcilliation Date</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Doc No.</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Invoice No.</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Plant Code</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Company Stockist Code</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Number</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Ref. Number</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Quantity</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Free Quantity</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Status</th>
                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Reconcilliation Type</th>
              </tr>
            </thead>
            <tbody>
              {poDetails?.map((item: any) => (
                <tr key={item?.invoice_product_order_product_id} className="text-sm">
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.batch || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{moment(item?.reconciliation?.created_date).format("DD-MM-YYYY h:mm a") || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.doc_number || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.comp_inv_number || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.plant || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.stockist_cmpcode || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.po_number || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.po_reference_order || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.quantity || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation?.free_quantity || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation_status || "N/A"}</td>
                  <td className="px-4 py-1 text-[.8rem] border">{item?.reconciliation_type || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="mt-2 text-center text-sm text-[#B5B5B5]">No data found</div>
      )}
    </div>
  );
};

export default Reconcilliation;
